import {DialogContent, FormattedDialogTitle} from "@dvrt/graphql-widgets";
import {Dialog} from "@mui/material";
import {FormattedMessage, MessageDescriptor, defineMessage} from "react-intl";

type InfoPopupProps = {
    open: boolean;
    onClose: () => void;

    translationId: MessageDescriptor;
};

const InfoPopup = ({open, onClose, translationId}: InfoPopupProps) => {
    return (
        <Dialog open={open}>
            <FormattedDialogTitle
                title={defineMessage({id: "info", defaultMessage: "Info"})}
                closingButton
                onClose={onClose}
            />
            <DialogContent>
                <FormattedMessage {...translationId} />
            </DialogContent>
        </Dialog>
    );
};

export default InfoPopup;
